export default __webpack_public_path__ + "static/media/affiliate-program-management-service.8edc59cf.svg";